import { useRef, useEffect, useState } from 'react';

const THRESHOLD = 0;
const SCROLL_DIRECTIONS = {
    up: 'up',
    down: 'down'
};

const useScrollDirection = () => {
    const [scrollDirection, setScrollDirection] = useState(SCROLL_DIRECTIONS.up);

    const blocking = useRef(false);
    const prevScrollY = useRef(0);

    useEffect(() => {
        prevScrollY.current = window.scrollY;

        const updateScrollDirection = () => {
            const { scrollY } = window;

            if (Math.abs(scrollY - prevScrollY.current) > THRESHOLD) {
                const newScrollDirection = scrollY > prevScrollY.current
                    ? SCROLL_DIRECTIONS.down
                    : SCROLL_DIRECTIONS.up;

                setScrollDirection(newScrollDirection);

                prevScrollY.current = scrollY > 0 ? scrollY : 0;
            }

            blocking.current = false;
        };

        const onScroll = () => {
            if (!blocking.current) {
                blocking.current = true;
                window.requestAnimationFrame(updateScrollDirection);
            }
        };

        window.addEventListener('scroll', onScroll);

        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    return scrollDirection;
};

export { useScrollDirection, SCROLL_DIRECTIONS };
